<script lang="ts">
	import type { Snippet } from 'svelte'

	let { title, crumb, actions }: { title: string; crumb?: Snippet; actions?: Snippet } = $props()
</script>

<header class="mt-2 mb-5 flex flex-wrap items-end justify-between gap-3">
	<div>
		{#if crumb}<div class="mb-1 text-[13px]">{@render crumb()}</div>{/if}
		<h1>{title}</h1>
	</div>
	{#if actions}<div class="flex flex-wrap gap-2">{@render actions()}</div>{/if}
</header>
